import produce from 'immer';

import { loginParser, permissionsParser, userParser } from 'shared/parsers';
import { shopPermissionsParser } from 'modules/shop/shared/parsers';
import { FETCH_SHOP_PERMISSIONS_SUCCESS } from 'modules/shop/store/shopActions';

import {
  LOGIN,
  LOGIN_SUCCESS,
  LOGIN_ERROR,
  LOGOUT_SUCCESS,
  EDIT_PROFILE,
  EDIT_PROFILE_SUCCESS,
  EDIT_PROFILE_ERROR,
  PERMISSIONS,
  GET_LOGGED_USER_SUCCESS,
} from './loginAction';

const initialState = {
  isPending: false,
  data: null,
  error: null,
};

export function auth(state = initialState, action) {
  const { response, type, payload } = action;

  switch (type) {
    case LOGIN:
      return { ...state, isPending: true };
    case LOGIN_SUCCESS:
      return { isPending: false, data: loginParser(response), error: null };
    case LOGIN_ERROR:
      return { isPending: false, data: null, error: response.message };
    case LOGOUT_SUCCESS:
      return initialState;
    case EDIT_PROFILE: {
      const { avatar } = action.payload;

      return produce(state, draftState => {
        draftState.data.user = { ...state.data.user, avatar }; // eslint-disable-line no-param-reassign
      });
    }
    case EDIT_PROFILE_SUCCESS: {
      const { firstName, name, phone, email, jobFunction, jobTitle } = response;

      return produce(state, draftState => {
        /* eslint-disable-next-line no-param-reassign */
        draftState.data.user = {
          ...state.data.user,
          firstName,
          name,
          phone,
          email,
          jobFunction,
          jobTitle,
        };
      });
    }
    case GET_LOGGED_USER_SUCCESS:
      return {
        ...state,
        data: { ...state.data, user: userParser(response) },
      };
    case PERMISSIONS:
      return {
        ...state,
        data: { ...state.data, permissions: permissionsParser(response.permissions) },
      };
    case FETCH_SHOP_PERMISSIONS_SUCCESS:
      return {
        ...state,
        data: { ...state.data, shopPermissions: shopPermissionsParser(payload) },
      };
    case EDIT_PROFILE_ERROR:
      return state;
    default:
      return state;
  }
}
